export const Replay = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <path d="M15 6C12.6131 6 10.3239 6.94821 8.63604 8.63604C6.94821 10.3239 6 12.6131 6 15H3L7 19L11 15H8C8 13.1435 8.7375 11.363 10.0503 10.0503C11.363 8.7375 13.1435 8 15 8C16.8565 8 18.637 8.7375 19.9497 10.0503C21.2625 11.363 22 13.1435 22 15C22 16.8565 21.2625 18.637 19.9497 19.9497C18.637 21.2625 16.8565 22 15 22C13.5 22 12.09 21.5 10.94 20.7L9.5 22.14C11.0811 23.3439 13.0128 23.9972 15 24C17.3869 24 19.6761 23.0518 21.364 21.364C23.0518 19.6761 24 17.3869 24 15C24 12.6131 23.0518 10.3239 21.364 8.63604C19.6761 6.94821 17.3869 6 15 6Z" />
    </svg>
  );
};
